import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import { css } from '@patternfly/react-styles';
import { useOUIAProps } from '../../helpers';
export var WizardNav = function WizardNav(_ref) {
  var children = _ref.children,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$returnList = _ref.returnList,
    returnList = _ref$returnList === void 0 ? false : _ref$returnList,
    ouiaId = _ref.ouiaId,
    _ref$ouiaSafe = _ref.ouiaSafe,
    ouiaSafe = _ref$ouiaSafe === void 0 ? true : _ref$ouiaSafe;
  var ouiaProps = useOUIAProps(WizardNav.displayName, ouiaId, ouiaSafe);
  var innerList = React.createElement("ol", {
    className: css(styles.wizardNavList)
  }, children);
  if (returnList) {
    return innerList;
  }
  return React.createElement("nav", Object.assign({
    className: css(styles.wizardNav, isOpen && styles.modifiers.expanded),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  }, ouiaProps), React.createElement("ol", {
    className: css(styles.wizardNavList)
  }, children));
};
WizardNav.displayName = 'WizardNav';